export default __webpack_public_path__ + "static/media/purchased_successfully.9bf206b7.svg";